// Value format should match this list https://en.wikipedia.org/wiki/List_of_HTTP_header_fields#Standard_request_fields
const HEADERS = {
  ACCEPT: 'Accept',
  ACCEPT_LANGUAGE: 'Accept-Language',
  CACHE_CONTROL: 'Cache-Control',
  CF_IPCOUNTRY: 'CF-IPCountry',
  CONTENT_TYPE: 'Content-Type',
  COOKIE: 'Cookie',
  PRAGMA: 'Pragma',
  REFERER: 'Referer',
  SET_COOKIE: 'Set-Cookie',
  USER_AGENT: 'User-Agent',
  X_ANON_ID: 'X-Anon-Id',
  X_CONTENT_ONLY: 'X-Content-Only',
  X_DATADOME: 'X-Datadome',
  X_DATADOME_CID: 'X-Datadome-Cid',
  X_DD_B: 'X-Dd-B',
  X_DEBUG_PIN: 'X-Debug-Pin',
  X_FORCED_LOCALE: 'X-Forced-Locale',
  X_FORWARDED_FOR: 'X-Forwarded-For',
  X_FORWARDED_HOST: 'X-Forwarded-Host',
  X_FORWARDED_PROTO: 'X-Forwarded-Proto',
  X_INTERNAL_FORWARDED_PATH: 'X-Internal-Forwarded-Path',
  X_INVOKE_OUTPUT: 'X-Invoke-Output',
  X_NEXT_APP: 'X-Next-App',
  X_NONCE_AUTHENTICATION: 'X-Nonce-Authentication',
  X_PAGE_ID: 'X-Page-Id',
  X_REMOTE_ADDRESS: 'X-Remote-Address',
  X_REQUEST_ID: 'X-Request-ID',
  X_SCREEN: 'X-Screen',
  X_USER_LOCALE: 'X-User-Locale',
  X_USER_ISO_LOCALE: 'X-User-Iso-Locale',
  X_VINTED_IN_APP: 'X-Vinted-In-App',
  X_V_UDT: 'X-V-UDT',
} as const

export const NEXT_HEADERS = Object.fromEntries(
  Object.entries(HEADERS).map(([key, value]) => [key, value.toLowerCase()]),
) as {
  [K in keyof typeof HEADERS]: Lowercase<(typeof HEADERS)[K]>
}
